export default (config = {}) => ({
    enableLightbox: config.enableLightbox ?? true,
    lightboxCaption: config.lightboxCaption ?? 'Galeria zdjęć',
    lightboxOpen: false,
    currentIndex: 0,
    currentImage: { url: '', alt: '', caption: '' },
    images: config.galleryImages ?? [],

    init() {
        // Zablokuj scroll body gdy lightbox jest otwarty
        this.$watch('lightboxOpen', (value) => {
            if (value) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        });
    },

    openLightbox(index) {
        if (!this.enableLightbox) return;

        this.currentIndex = index;
        this.updateCurrentImage();
        this.lightboxOpen = true;

        // Dodaj obsługę klawiszy
        document.addEventListener('keydown', this.handleKeydown.bind(this));
    },

    closeLightbox() {
        this.lightboxOpen = false;
        document.removeEventListener('keydown', this.handleKeydown);
    },

    nextImage() {
        if (this.currentIndex < this.images.length - 1) {
            this.currentIndex++;
            this.updateCurrentImage();
        }
    },

    prevImage() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.updateCurrentImage();
        }
    },

    updateCurrentImage() {
        if (this.images[this.currentIndex]) {
            this.currentImage = this.images[this.currentIndex];
        }
    },

    handleKeydown(event) {
        switch (event.key) {
            case 'ArrowRight':
                this.nextImage();
                break;
            case 'ArrowLeft':
                this.prevImage();
                break;
            case 'Escape':
                this.closeLightbox();
                break;
        }
    }
});